import { useMutation } from '@tanstack/react-query';

import type { UpdateEmployeeChildrenArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: UpdateEmployeeChildrenArgs) => {
  return employeeService.updateEmployeeChildren(data);
};

export const useEmployeeUpdateChildrenMutation = () => {
  return useMutation<unknown, unknown, UpdateEmployeeChildrenArgs>(mutationFn);
};
